import { render, staticRenderFns } from "./CompanyAdmin.vue?vue&type=template&id=9c2f8ee6&"
import script from "./CompanyAdmin.vue?vue&type=script&lang=js&"
export * from "./CompanyAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports